import { render, staticRenderFns } from "./coverage_descriptions.vue?vue&type=template&id=604371a6&"
import script from "./coverage_descriptions.vue?vue&type=script&lang=js&"
export * from "./coverage_descriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports